import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type {
  TableSettings,
  TablesSettingsResponseBody,
} from '@ipfabric/utils';
import {
  AUTO_SIZED_COLUMNS_DEFAULT,
  type TableCommandFactory,
} from 'components/Table/model/TableModel';
import { TABLE_COLUMN_MIN_WIDTH } from 'components/Table/tableSettings';
import { produce } from 'immer';
import { createUrl } from 'utils/createUrl';
import { withCommandModelLoadingIndicator } from 'utils/loading/withCommandModelLoadingIndicator';

const sanitizeColumnWidths: (settings: TableSettings) => TableSettings =
  produce((draft) => {
    if (!draft.columnWidth) {
      return;
    }
    for (const key of Object.keys(draft.columnWidth)) {
      // Fixed noUncheckedIndexedAccess NIM-19408
      if (draft.columnWidth[key]! < TABLE_COLUMN_MIN_WIDTH) {
        draft.columnWidth[key] = TABLE_COLUMN_MIN_WIDTH;
      }
    }
  });
export const loadTableSettings: TableCommandFactory =
  (cmdContext) => async () => {
    const tableId = cmdContext.getState().id;
    if (tableId === undefined) {
      stumble('Trying to load settings but table has no id');
      return;
    }
    const loadSettings = async () => {
      try {
        return await withCommandModelLoadingIndicator(
          cmdContext,
          'loadingSettings',
        )(() =>
          cmdContext.api.request<TablesSettingsResponseBody>({
            url: createUrl('/tables/settings', {
              name: tableId,
            }),
          }),
        );
      } finally {
        cmdContext.updateState((draft) => {
          draft.loadedSettings = true;
        });
      }
    };

    const result = await loadSettings();

    cmdContext.updateState((draft) => {
      if (cmdContext.getState().externalSettings === undefined) {
        draft.settings =
          (result.userSettings.autoSizedColumns ?? AUTO_SIZED_COLUMNS_DEFAULT)
            ? // if auto sized columns feature is turned on, discard column widths from API
              // otherwise they would overwrite already calculated auto sizes.
              {
                ...result.userSettings,
                columnWidth: draft.settings.columnWidth,
              }
            : sanitizeColumnWidths(result.userSettings);
      }
      draft.filterPresets = result.filters;
    });
  };
